
import { Placement } from '@post-office/placements-frontend/teams-app-changeboarding';
export default Placement;
